export default __webpack_public_path__ + "search-examples-search-ui-and-maps-sdk-1200-22a920418b580bb2fe90c3cb6874c364.webp";